export default "__VITE_ASSET__DnYWX9Vm__"